
export const deepClone = (data) => {
  return JSON.parse(JSON.stringify(data));
};

export const notEmpty = (value) => {
  // 先处理基本类型
  // null
  // undefined
  if (value === undefined || value === null) {
    return false;
  }

  const valueType = typeof value;

  // string
  if (valueType === 'string') {
    return value !== '';
  }

  // number bigint boolean
  if (valueType === 'number' || valueType === 'bigint' || valueType === 'boolean' || valueType === 'function') {
    return true;
  }

  // symbol
  if (valueType === 'symbol') {
    return value.toString() !== 'Symbol()';
  }

  if (valueType === 'object') {
    // Bigint/Symbol no new
    if (value instanceof String || value instanceof Array) {
      return value.length !== 0;
    }

    if (value instanceof Number || value instanceof Boolean) {
      return true;
    }

    if (value instanceof Map || value instanceof Set) {
      return value.size > 0;
    }

    if (value instanceof WeakMap || value instanceof WeakSet) {
      console.error('WeakMap和WeakSet无法以通用的方式判断是否为空。');
      return false;
    }

    if (value instanceof RegExp) {
      return value.toString() !== '/(?:)/';
    }

    if (value instanceof Date) {
      return value.toString() !== 'Invalid Date';
    }

    const typedArrayTypes = [
      Int8Array,
      Uint8Array,
      Uint8ClampedArray,
      Int16Array,
      Uint16Array,
      Int32Array,
      Uint32Array,
      Float32Array,
      Float64Array
    ];

    for (let arrayType of typedArrayTypes) {
      if (value instanceof arrayType) {
        return value.length;
      }
    }
    return Object.keys(value).length > 0;
  }
};

export const isEmpty = (value) => !notEmpty(value);

export const everyNotEmpty = (...arg) => {
  for (let a of arg) {
    if (isEmpty(a)) {
      return false;
    }
  }
  return true;
};

export const everyIsEmpty = (...arg) => {
  for (let a of arg) {
    if (notEmpty(a)) {
      return false;
    }
  }
  return true;
};

export const dateFormat = (date, format = 'YYYY-MM-DD', split = '-') => {
  let dateVal = '';
  const val = new Date(date);
  const yy = val.getFullYear();
  const fixZero = (num) => num < 10 ? `0${num}` : num;
  const mm = fixZero(val.getMonth() + 1);
  const dd = fixZero(val.getDate());
  const hh = fixZero(val.getHours());
  const mf = fixZero(val.getMinutes());
  const ms = fixZero(val.getSeconds());
  if (format === 'YYYY-MM-DD') {
    dateVal = `${yy}${split}${mm}${split}${dd}`;
  } else {
    dateVal = `${yy}${split}${mm}${split}${dd} ${hh}:${mf}:${ms}`;
  }
  return dateVal;
};



// WEBPACK FOOTER //
// ./src/plugins/utils.js